import React, {useState} from 'react'
import {Button, InputAdornment, TextField, useTheme} from '@mui/material'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRightRounded'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeftRounded'
import {useLocation, useNavigate} from 'react-router-dom'
import Guard from 'routes/Guard'
import kc from 'web-common/services/auth'
import LoginGuard from 'routes/LoginGuard'
import {useTranslation} from 'react-i18next'

const SearchAssistant = () => {
  const theme = useTheme()
  const [t, i18n] = useTranslation()
  const [query, setQuery] = useState('')

  const isRTL = i18n.dir() === 'rtl'

  const navigate = useNavigate()
  const location = useLocation()

  const openGuardedLink = async (
    path: string,
    query: string,
    guard?: Guard
  ) => {
    let url = path

    if (guard) {
      const hasPermission = await guard.hasPermission()
      if (!hasPermission) {
        const fallbackUrl = guard.getFallbackUrl(location)
        if (fallbackUrl === '/login') {
          await kc.automaticLoginFlow(window.location.origin + path)
          return
        } else {
          url = fallbackUrl
        }
      }
    }

    navigate(url, {
      state: {
        message: query
      }
    })
  }

  const navigateToChat = () => {
    if (query !== '') {
      openGuardedLink('/chat', query, LoginGuard)
    }
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      navigateToChat()
    }
  }

  const startChat = () => {
    navigateToChat()
  }

  return (
    <TextField
      placeholder={t('fnd-home-search-placeholder')}
      multiline
      onChange={(e) => setQuery(e.target.value)}
      onKeyDown={handleKeyDown}
      sx={{
        marginTop: 4,
        zIndex: 4,
        width: {xs: '90%', sm: 400},
        '& .MuiOutlinedInput-root': {
          borderRadius: '12px',
          backgroundColor: theme.palette.common.white,
          height: '90px',
          paddingTop: '8px',
          alignItems: 'flex-start',
          overflow: 'hidden'
        },
        '& .MuiInputBase-inputMultiline': {
          height: '100% !important',
          maxHeight: '100%',
          overflowY: 'auto',
          resize: 'none',
          paddingRight: '40px',
          boxSizing: 'border-box'
        }
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment
            position="end"
            sx={{
              alignSelf: 'flex-start',
              marginTop: '12px',
              marginRight: -0.5
            }}
          >
            <Button
              size="small"
              onClick={startChat}
              sx={{
                minWidth: 0,
                width: 22,
                height: 22,
                padding: 0,
                borderRadius: '50%',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
                '&:hover': {
                  backgroundColor: theme.palette.primary.dark
                }
              }}
            >
              {isRTL ? (
                <KeyboardArrowLeftIcon sx={{fontSize: '24px'}} />
              ) : (
                <KeyboardArrowRightIcon sx={{fontSize: '24px'}} />
              )}
            </Button>
          </InputAdornment>
        )
      }}
    />
  )
}

export default SearchAssistant
